import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './auth/AuthContext';
import ProtectedRoute from './routes/ProtectedRoute';
import LoginPage from './pages/auth/LoginPage';
import RegisterPage from './pages/auth/RegisterPage';
import ForgotPasswordPage from './pages/auth/ForgotPasswordPage';
import AddProductPage from './pages/admin/AddProductPage';
import AdminOverviewPage from './pages/admin/AdminOverviewPage';
import AdminBankAccountPage from './pages/admin/AdminBankAccountPage';
import AdminAlertsPage from './pages/admin/AdminAlertsPage';
import StaffDashboard from './pages/staff/StaffDashboard';
import StaffLayout from './pages/staff/StaffLayout';
import StaffOrdersPage from './pages/staff/StaffOrdersPage';
import StaffOrderDetailPage from './pages/staff/StaffOrderDetailPage';
import StaffProfilePage from './pages/staff/ProfilePage';
import AdminLayout from './pages/admin/AdminLayout';
import CustomerDashboard from './pages/customer/CustomerDashboard';
import CustomerLayout from './pages/customer/CustomerLayout';
import CustomerWithdrawPage from './pages/customer/CustomerWithdrawPage';
import CustomerPaymentPage from './pages/customer/CustomerPaymentPage';
import CustomerOrderSuccessPage from './pages/customer/CustomerOrderSuccessPage';
import CustomerOrdersPage from './pages/customer/CustomerOrdersPage';
import CustomerOrderDetailPage from './pages/customer/CustomerOrderDetailPage';
import CustomerProfilePage from './pages/customer/ProfilePage';
import WithdrawPage from './pages/staff/WithdrawPage';
import UsersPage from './pages/admin/UsersPage';
import ProductsPage from './pages/admin/ProductsPage';
import EditProductPage from './pages/admin/EditProductPage';
import InventoryHistoryPage from './pages/admin/InventoryHistoryPage';
import InventoryHistoryIndex from './pages/admin/inventory_history';
import AdminOrdersPage from './pages/admin/AdminOrdersPage';
import AdminOrderDetailPage from './pages/admin/AdminOrderDetailPage';
import ProfilePage from './pages/admin/ProfilePage';
import AdminCategoriesPage from './pages/admin/AdminCategoriesPage';

function HomeRouter() {
  const { profile } = useAuth();
  if (!profile) return null;
  if (profile.role === 'admin') return <Navigate to="/admin/dashboard" replace />;
  if (profile.role === 'staff') return <Navigate to="/staff" replace />;
  return <Navigate to="/customer" replace />;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<ProtectedRoute allow={['admin','staff','customer']} />}> 
            <Route index element={<HomeRouter />} />
          </Route>

          <Route path="/admin" element={<ProtectedRoute allow={['admin']} />}> 
            <Route element={<AdminLayout />}>
              <Route index element={<Navigate to="/admin/dashboard" replace />} />
              <Route path="dashboard" element={<AdminOverviewPage />} />
              <Route path="alerts" element={<AdminAlertsPage />} />
              <Route path="categories" element={<AdminCategoriesPage />} />
              <Route path="products" element={<ProductsPage />} />
              <Route path="orders" element={<AdminOrdersPage />} />
              <Route path="orders/:id" element={<AdminOrderDetailPage />} />
              <Route path="users" element={<UsersPage />} />
              <Route path="addproduct" element={<AddProductPage />} />
              <Route path="products/:id/edit" element={<EditProductPage />} />
              <Route path="products/:id/history" element={<InventoryHistoryPage />} />
              <Route path="inventory_history" element={<InventoryHistoryIndex />} />
              <Route path="payment-account" element={<AdminBankAccountPage />} />
              <Route path="profile" element={<ProfilePage />} />
            </Route>
          </Route>

          <Route path="/staff" element={<ProtectedRoute allow={['staff']} />}> 
            <Route element={<StaffLayout />}> 
              <Route index element={<StaffDashboard />} />
              <Route path="orders" element={<StaffOrdersPage />} />
              <Route path="orders/:id" element={<StaffOrderDetailPage />} />
              <Route path="withdraw" element={<WithdrawPage />} />
              <Route path="profile" element={<StaffProfilePage />} />
            </Route>
          </Route>

          <Route path="/customer" element={<ProtectedRoute allow={['customer']} />}> 
            <Route element={<CustomerLayout />}> 
              <Route index element={<CustomerDashboard />} />
              <Route path="orders" element={<CustomerOrdersPage />} />
              <Route path="orders/:id" element={<CustomerOrderDetailPage />} />
              <Route path="withdraw" element={<CustomerWithdrawPage />} />
              <Route path="payment" element={<CustomerPaymentPage />} />
              <Route path="payment/success" element={<CustomerOrderSuccessPage />} />
              <Route path="profile" element={<CustomerProfilePage />} />
            </Route>
          </Route>

          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;